<div>
  @if (title) {
    <h2>{{title}}</h2>
  }
  @if (type === "image" && src) {
    <div class='image-preview'>
      <img [src]='src'/>
    </div>
  }
  @if (canEdit) {
    <div class='actions'>
      <button (click)='openUpload()' mat-flat-button color='accent'>{{uploadLabel | translate}}</button>
      @if (src && removeRoute) {
        <button (click)='remove()' mat-flat-button color='warn'>{{'Elimina' | translate}}</button>
      }
    </div>
  }
</div>